var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8"},[_c('p',{staticClass:"text-white text-sm mb-4"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bg-tertiary bg-opacity-25 h-px"})])}
var staticRenderFns = []

export { render, staticRenderFns }